export const snippetBuilder = (baseSetup, defaultSettings) => {
  return `
    const baseSetup = ${baseSetup};
  
    const defaultSettings = ${defaultSettings};
    const DEFAULT_MESSAGES = {
      OFFER_MESSAGE: 'Hey! Would you like to get some help?',
      HELP: 'How would you like to get help?',
      CALL: 'Call us.',
      EMAIL: 'Email us anytime.',
      CHAT_WORKING_HRS: 'Chat with an agent',
      CHAT_SCHEDULE: 'If you need to chat with one of our agents, we\\'ll be available to help you from <br /><b>{schedule}</b>',
      NO_CHAT_SCHEDULE: 'Hey there! Unfortunately, we don\\'t have any scheduled times for chatting with our agents later today.',
      LET_US_KNOW: 'We\\'re sorry about that! Is there anything else we can help you with in the meantime? Let us know via {channel} and we\\'ll do our best to assist you.',
      WILL_BE_OPEN_IN: 'An agent should be ready to chat with you in approximately <b>{hh}h {mm}m</b>',
      CURRENT_TIME: 'As of right now, it\\'s <b>{currentTime}</b> Please feel free to come back and chat with us then.'
    };
  
    const icons = {
      close:
        'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41',
      chat:
        'M20,18c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4l0,18l4-4H20z M4,17.2V4h16v12H5.2L4,17.2z M6,12h8v2H6V12z M6,9h12v2H6V9z M6,6h12v2H6V6z',
      maximize: 'M4,8H8V4H20V16H16V20H4V8M16,8V14H18V6H10V8H16M6,12V18H14V12H6Z',
      phone:
        'M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z',
      email:
        'M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z',
      spinner: 'M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z'
    };
  
    const template = document.createElement('template');
    template.innerHTML = \`
      <style>
        #ecs-web-chat-container {
          --ecs-web-chat-min-height: 52px;
          --ecs-web-chat-max-height: 632px;
          --ecs-web-chat-max-width: 400px;
          --ecs-web-chat-max-offschedule-width: 324px;
          --ecs-web-icons-color: #0007;
          --ecs-web-base-font-color: #444;
          --ecs-web-base-border-color: #0002;s
          --ecs-web-accent-border-color: #0451a1;
          
          font-family: 'Roboto', 'Lato', 'Montserrat', Open Sans, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    
          width: var(--ecs-web-chat-min-height);
          height: var(--ecs-web-chat-min-height);
          border-radius: 40px;
          box-shadow: 0 0 5px #0007;
          overflow: hidden;
          position: fixed;
          z-index: 2147483647;
          bottom: 40px;
          right: 40px;
    
          backdrop-filter: saturate(200%) blur(30px);
          background-color: hsla(0, 0%, 100%, 0.8);
          color: var(--ecs-web-base-font-color);
    
          transition: all 0.3s ease;
        }
        @media (max-width: 480px) {
          #ecs-web-chat-container {
            right: 50%;
            transform: translateX(50%);
          }
        }
        @media (max-height: 712px) {
          #ecs-web-chat-container {
            bottom: 50%;
            transform: translateY(50%);
          }
        }
        @media (max-width: 480px) and (max-height: 712px) {
        #ecs-web-chat-container {
            transform: translate(50%, 50%);
          }
        }
        #ecs-web-chat-container.loading {
          width: 220px;
        }
        #ecs-web-chat-container:has(iframe[src]):not(.loading) {
          width: var(--ecs-web-chat-max-width);
        }
        #ecs-web-chat-container.expanded {
          height: var(--ecs-web-chat-max-height);
          width: var(--ecs-web-chat-max-width);
          border-radius: 12px;
        }
        #min-max-window-toggle-btn {
          width: var(--ecs-web-chat-min-height);
          height: var(--ecs-web-chat-min-height);
          display: none;
          cursor: pointer;
        }
        #ecs-web-chat-container.loaded #min-max-window-toggle-btn {
          display: block;
        }
        #min-max-window-toggle-btn svg {
          padding: 12px;
          position: relative;
        }
        .min, .max {
          position: absolute;
          opacity: 0;
          transition: all .3s ease;
        }
        svg {
          fill: var(--ecs-web-icons-color);
        }
        #ecs-web-chat-container.expanded .min,
        #ecs-web-chat-container:not(.expanded):not(.loading) .max {
          opacity: 1;
        }
        #ecs-web-chat-container .chat-header {
          display: grid;
          height: var(--ecs-web-chat-min-height);
        }
        #ecs-web-chat-container.loaded .chat-header {
          grid-template-columns: auto var(--ecs-web-chat-min-height);
        }
        .chat-body,
        .off-schedule-body {
          max-width: 100%;
          width: var(--ecs-web-chat-max-width);
          height: calc(var(--ecs-web-chat-max-height) - var(--ecs-web-chat-min-height));
        }
        .chat-body {
          display: none;
        }
        .off-schedule-body {
          display: block;
        }
        .chat-body:has(iframe[src]) {
          display: block;
        }
        .chat-body:has(iframe[src]) + .off-schedule-body {
          display: none;
        }
        #ecs-web-chat {
          border: none;
          overflow: auto;
          display: none;
          width: 100%;
          height: 100%;
        }
        #ecs-web-chat-container.expanded #ecs-web-chat {
          display: block;
        }
        #chat-now-btn {
          border: none;
          cursor: pointer;
          overflow: auto;
          width: var(--ecs-web-chat-min-height);
          height: var(--ecs-web-chat-min-height);
          padding: 14px;
          box-sizing: border-box;
          overflow: hidden;
        }
        #ecs-web-chat-container.loaded:not(.expanded):not(.loading) .header-message {
          display: none;
        }
        #ecs-web-chat-container.loaded:has(iframe[src]):not(.loading) .header-message {
          display: block;
        }
        .header-message {
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 0 12px 0 16px;
          line-height: var(--ecs-web-chat-min-height);
        }
        .pulse {
          animation: pulse 1.5s ease-in-out infinite both;
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(0.9); }
          100% { transform: scale(1); }
        }
    
        /* Offer for some help */
        #offer-message {
          width: 220px;
          padding: 8px 24px 8px 12px;
          border-radius: 8px;
          position: fixed;
          z-index: 2147483647;
          bottom: 108px;
          right: 42px;
    
          backdrop-filter: saturate(200%) blur(30px);
          background-color: hsla(0, 0%, 100%, 0.8);
          color: var(--ecs-web-base-font-color);
          box-shadow: 0 0 5px #0007;
    
          transition: all 0.5s ease;
          transform: translateX(120px) translateY(80px) scale(0);
        }
    
        #offer-message.offer {
          transform: translateX(0) translateY(0) scale(1);
        }
    
        #offer-message::before {
          content: '';
          display: block;
          position: absolute;
          bottom: -12px;
          right: 12px;
          border-right: 12px solid transparent;
          border-top: 12px solid #dcdcdc;
          border-left: 12px solid transparent;
          border-bottom: none;
        }
    
        #close-offer-message-btn {
          position: absolute;
          top: 8px;
          right: 12px;
          width: 20px;
          height: 20px;
          cursor: pointer;
          fill: transparent;
          transition: all 0.3s ease;
        }
    
        #offer-message:hover  #close-offer-message-btn {
          fill: var(--ecs-web-icons-color, #0005);
        }
    
        /* Off schedule */
        .off-schedule-body {
          width: var(--ecs-web-chat-max-offschedule-width);
          margin: 0 auto;
        }
        .off-schedule-body header.title {
          font-size: 20px;
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }
        a {
          text-decoration: none;
        }
        .option-box {
          border: 1px solid var(--ecs-web-base-border-color);
          border-radius: 8px;
          box-sizing: border-box;
          padding: 20px;
          text-align: center;
          margin-bottom: 12px;
          color: var(--ecs-web-base-font-color);
          transition: all 0.3s ease;
        }
        .option-box:hover {
          box-shadow: 0 0 5px #0001;
          background-color: #fff4;
        }
        .option-box:hover svg {
          fill: var(--ecs-web-accent-border-color);
        }
        .option-box .title {
           font-weight: bold;
           font-size: 16px;
        }
        .option-box .message, 
        .option-box .current,
        .option-box .schedule,
        .option-box .time-zone,
        .option-box .diff {
           font-size: 14px;
           padding: 8px 0 4px;
           opacity: 0.75;
        }
        .will-open + .will-open {
          padding: 4px 0 4px;
        }
        .hidden {
          display: none;
        }
        .option-box-icon {
           width: 24px;
           height: 24px;
           padding-right: 4px;
           vertical-align: text-bottom;
        }
      </style>
      <div id="offer-message">
        <svg id="close-offer-message-btn">
          <path d="\${icons.close}"></path>
        </svg>
        <span class="offer-message-text"></span>
      </div>
      <section id="ecs-web-chat-container" class="pulse">
        <header class="chat-header">
          <div id="chat-now-btn">
            <svg>
              <path d="\${icons.chat}"></path>
            </svg>
          </div>
          <div class="header-message"></div>
          <div id="min-max-window-toggle-btn">
            <svg viewBox="0 0 24 24">
              <rect class="min" x="4" y="12" width="16" height="3"></rect>
              <path class="max" d="\${icons.maximize}"></path>
            </svg>
          </div>
        </header>
        <section class="chat-body">
          <iframe id="ecs-web-chat" scrolling="no"></iframe>
        </section>
        <section class="off-schedule-body">
          <header class="title">\${DEFAULT_MESSAGES.HELP}</header>
            <a id="current-org-time">
              <div class="option-box">
                <div class="title">
                  <svg class="option-box-icon">
                    <path d="\${icons.chat}"></path>
                  </svg>
                  <span>\${DEFAULT_MESSAGES.CHAT_WORKING_HRS}</span>
                </div>
                <div class="will-open schedule"></div>
                <div class="will-open time-zone"></div>
                <div class="will-open current"></div>
                <div class="will-open diff"></div>
            </div>
          </a>
          <a id="call">
            <div class="option-box">
                <div class="title">
                  <svg class="option-box-icon">
                    <path d="\${icons.phone}"></path>
                  </svg>
                  <span>\${DEFAULT_MESSAGES.CALL}</span>
                </div>
                <div class="call-us message"></div>
            </div>
          </a>
          <a id="email">
            <div class="option-box">
              <div class="title">
                <svg class="option-box-icon">
                  <path d="\${icons.email}"></path>
                </svg>
                <span>\${DEFAULT_MESSAGES.EMAIL}</span>
              </div>
              <div class="email-us message"></div>
            </div>
          </a>
        </section>
      </section>
    \`;
    
    let updateCurrentTimeIntervalRef = null;
  
    class ECSSpinner extends HTMLElement {
      constructor() {
        super();
        this.render();
      }
  
      attributeChangedCallback() {}
  
      render() {
        this.message = this.getAttribute('message') || '';
        this.innerHTML = \`
              <style>
                .spinner {
                  display: grid;
                  grid-template-columns: 28px min-content;
                }
                .spinner-icon {
                  fill: var(--ecs-web-icons-color);
                  width: 28px;
                  padding: 12px 0;
                  display: inline-block;
                  animation: spinner 1s linear infinite;
                }
                .message {
                  padding: 0 12px;
                }
                @keyframes spinner {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              </style>
              <div class="spinner">
                <svg class="spinner-icon" viewBox="0 0 24 24">
                  <path d="\${icons.spinner}"></path>
                </svg>
                <div class="\${this.message ? 'message' : ''}">\${this.message}</div>
              </div>
            \`;
      }
    }
  
    class ECSWebChat extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
      }
  
      static get observedAttributes() {
        return [];
      }
  
      attributeChangedCallback() {
        this.render();
      }
  
      connectedCallback() {
        const chatNowBtn = this.shadowRoot.querySelector('#chat-now-btn');
        chatNowBtn && chatNowBtn.addEventListener('click', this.chatNow);
        const minMaxBtn = this.shadowRoot.querySelector('#min-max-window-toggle-btn');
        minMaxBtn && minMaxBtn.addEventListener('click', this.toggleWindow);
        const webChatIframe = this.shadowRoot.querySelector('#ecs-web-chat');
        webChatIframe && webChatIframe.addEventListener('load', this.ecsWebChatLoaded);
        const closeOfferMessageBtn = this.shadowRoot.querySelector('#close-offer-message-btn');
        closeOfferMessageBtn && closeOfferMessageBtn.addEventListener('click', this.removeOfferMessage);
  
        this.render();
      }
  
      disconnectedCallback() {
        const chatNowBtn = this.shadowRoot.querySelector('#chat-now-btn');
        chatNowBtn && chatNowBtn.removeEventListener('click', this.chatNow);
        const minMaxBtn = this.shadowRoot.querySelector('#min-max-window-toggle-btn');
        minMaxBtn && minMaxBtn.removeEventListener('click', this.toggleWindow);
        const webChatIframe = this.shadowRoot.querySelector('#ecs-web-chat');
        webChatIframe && webChatIframe.removeEventListener('load', this.ecsWebChatLoaded);
        const closeOfferMessageBtn = this.shadowRoot.querySelector('#close-offer-message-btn');
        closeOfferMessageBtn && closeOfferMessageBtn.removeEventListener('click', this.removeOfferMessage);
      }
  
      ecsWebChatLoaded = event => {
        if (event.target.src) {
          this.contentLoaded();
          this.maximize();
          this.stopSpinner();
        }
      };
  
      contentLoaded() {
        const ecsWebChatContainer = this.shadowRoot.querySelector('#ecs-web-chat-container');
        ecsWebChatContainer.classList.add('loaded');
      }
  
      chatNow = async () => {
        this.removePulse();
        this.removeOfferMessage();
        this.removeChatNowBtn();
        this.startSpinner();
  
        const settings = await this.updateStoredSettings();
  
        const now = new Date();
        const today = now.toISOString().substring(0, 10);
        let holiday = settings.holidays && settings.holidays.find(holiday => holiday.date.startsWith(today));
  
        let schedule;
  
        if (holiday) {
          schedule = holiday.schedule;
        } else {
          const weekDay = new Date().getDay(); /* 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on. */
          switch (weekDay) {
            case 0:
              schedule = this.settings.workingHrsSchedule.sunday;
              break;
            case 1:
              schedule = this.settings.workingHrsSchedule.monday;
              break;
            case 2:
              schedule = this.settings.workingHrsSchedule.tuesday;
              break;
            case 3:
              schedule = this.settings.workingHrsSchedule.wednesday;
              break;
            case 4:
              schedule = this.settings.workingHrsSchedule.thursday;
              break;
            case 5:
              schedule = this.settings.workingHrsSchedule.friday;
              break;
            case 6:
              schedule = this.settings.workingHrsSchedule.saturday;
              break;
          }
        }
  
        let withinWorkingHours = false;
        
        const orgTimeZone = this.settings.ianaTimeZone;
        const orgTime = new Date(new Date().toLocaleString('en-US', { timeZone: orgTimeZone }));
        const orgTimeMinutes = orgTime.getHours() * 60 + orgTime.getMinutes();
        schedule.forEach(({ from, to }) => {
          if (isNaN(from) || isNaN(to)) return;
          if (orgTimeMinutes >= from && orgTimeMinutes < to) {
            withinWorkingHours = true;
          }
        });
  
        if (withinWorkingHours) {
          this.loadEcsWebChat();
        } else {
          this.loadOffScheduleView(schedule);
        }
      };
  
      toggleWindow = () => {
        const ecsWebChatContainer = this.shadowRoot.querySelector('#ecs-web-chat-container');
        if (ecsWebChatContainer.classList.contains('expanded')) {
          this.minimize();
        } else {
          this.maximize();
        }
      };
  
      maximize = () => {
        const ecsWebChatContainer = this.shadowRoot.querySelector('#ecs-web-chat-container');
        ecsWebChatContainer.classList.add('expanded');
      };
  
      minimize = () => {
        const ecsWebChatContainer = this.shadowRoot.querySelector('#ecs-web-chat-container');
        ecsWebChatContainer.classList.remove('expanded');
      };
  
      removeOfferMessage = () => {
        clearTimeout(this.showOfferMessageRef);
        const offerMessage = this.shadowRoot.querySelector('#offer-message');
        offerMessage && offerMessage.remove();
      };
  
      render() {
        let storedSettings = JSON.parse(localStorage.getItem('ECSWebChat.config'));
        this.settings = storedSettings || defaultSettings;
  
        if (this.settings && this.settings.openChatOfferAfter && this.settings.openChatOfferAfter !== -1) {
          this.shadowRoot.querySelector('.offer-message-text').innerHTML =
            this.settings.offerMessage || DEFAULT_MESSAGES.OFFER_MESSAGE;
          this.showOfferMessageRef = setTimeout(() => {
            this.showOfferMessage();
          }, this.settings.openChatOfferAfter * 1000);
        }
      }
  
      removeChatNowBtn() {
        const chatNowBtn = this.shadowRoot.querySelector('#chat-now-btn');
        chatNowBtn.removeEventListener('click', this.chatNow);
        chatNowBtn.remove();
      }
  
      removePulse() {
        const ecsWebChatContainer = this.shadowRoot.querySelector('#ecs-web-chat-container');
        ecsWebChatContainer.classList.remove('pulse');
      }
  
      showOfferMessage() {
        const offerMessage = this.shadowRoot.querySelector('#offer-message');
        offerMessage && offerMessage.classList.add('offer');
      }
  
      startSpinner() {
        this.shadowRoot.querySelector('.header-message').innerHTML = '<ecs-spinner message="Loading..."></ecs-spinner>';
        this.shadowRoot.querySelector('#ecs-web-chat-container').classList.add('loading');
      }
  
      stopSpinner() {
        this.shadowRoot.querySelector('.header-message').innerText = this.settings && this.settings.welcomeMessage;
        this.shadowRoot.querySelector('#ecs-web-chat-container').classList.remove('loading');
      }
  
      loadEcsWebChat() {
        const params = new URLSearchParams();
        params.append('chatIdentifier', baseSetup.orgId);
        params.append('chatURI', baseSetup.businessProcessEndPoint);
        params.append('configId', baseSetup.configId);
        if (baseSetup.customer && baseSetup.customer.enabled) {
          params.append('customerName', baseSetup.customer.name);
          params.append('customerEmail', baseSetup.customer.email);
        }
        
        const fullUrl = \`\${baseSetup.baseUrl}/#/ChatNow?\${params.toString()}\`;
        const ecsWebChatIframe = this.shadowRoot.querySelector('#ecs-web-chat');
        
        ecsWebChatIframe.src = fullUrl;
      }
      
      updateCurrentTime(schedule) {
        const currentTime = new Date().toLocaleTimeString('en-US', {
          timeZone: this.settings.ianaTimeZone
        });
        this.shadowRoot.querySelector('.current').innerHTML = DEFAULT_MESSAGES.CURRENT_TIME.replace('{currentTime}', currentTime);
        
        this.updateTimeDiff(schedule);
      }
      
      updateTimeDiff(schedule) {
        const orgTimeZone = new Date().toLocaleString('en-US', {
          timeZone: this.settings.ianaTimeZone
        });
        const orgDateTime = new Date(orgTimeZone);
        const orgOpenDateTime = new Date(orgTimeZone);
        const willBeOpenIn = [];
        
        schedule.forEach(timespan => {
          if (!timespan.from && !timespan.to) return;
          
          const fromH = Math.trunc(timespan.from / 60);
          const fromM = timespan.from % 60;
          orgOpenDateTime.setHours(fromH, fromM, orgOpenDateTime.getSeconds());
          
          const diffToOpen = orgDateTime - orgOpenDateTime;
          const willBeOpen = diffToOpen < 0;
          
          const totalDiffSeconds = Math.abs(diffToOpen) / 1000;
          const mm = Math.trunc(totalDiffSeconds / 60) % 60;
          const hh = Math.trunc(totalDiffSeconds / 60 / 60);
          
          if (willBeOpen) {
            willBeOpenIn.push({ hh, mm });
          }
        });
        
        if (willBeOpenIn.length) {
            this.shadowRoot.querySelector('.schedule').innerHTML = DEFAULT_MESSAGES.CHAT_SCHEDULE;
            this.shadowRoot.querySelector('.time-zone').innerHTML = this.settings.msTimeZone;            
            this.shadowRoot.querySelector('.diff').innerHTML =  DEFAULT_MESSAGES.WILL_BE_OPEN_IN.replace('{hh}', willBeOpenIn[0].hh).replace('{mm}', willBeOpenIn[0].mm);
            this.shadowRoot.querySelector('.time-zone').classList.remove('hidden');
            this.shadowRoot.querySelector('.current').classList.remove('hidden');
            this.shadowRoot.querySelector('.diff').classList.remove('hidden');
          } else {
            let channel = this.settings.phone ? 'phone' : '';
            if (this.settings.email) {
              channel += this.settings.phone ? ' or email' : 'email';
            }
            const letUsKnow = channel ? DEFAULT_MESSAGES.LET_US_KNOW.replace('{channel}', channel) : null;
            const noChatSchedule = \`\${DEFAULT_MESSAGES.NO_CHAT_SCHEDULE}\${letUsKnow || ''}\`;
            this.shadowRoot.querySelector('.schedule').innerHTML = noChatSchedule;
            this.shadowRoot.querySelector('.time-zone').classList.add('hidden'); 
            this.shadowRoot.querySelector('.current').classList.add('hidden');
            this.shadowRoot.querySelector('.diff').classList.add('hidden');
          }
      }
  
      loadOffScheduleView(schedule) {
        this.stopSpinner();
        this.maximize();
        this.contentLoaded();
  
        let timeSpan = '';
        schedule.forEach(timespan => {
          if (!timespan.from && !timespan.to) return;
          let fromH = Math.trunc(timespan.from / 60);
          const fromM = (timespan.from % 60);
          let toH = Math.trunc(timespan.to / 60);
          const toM = (timespan.to % 60);
          
          const fromAmPm = fromH >= 12 ? 'PM' : 'AM';
          const toAmPm = toH >= 12 ? 'PM' : 'AM';
          
          fromH = fromH > 12 ? fromH - 12 : fromH;
          toH = toH > 12 ? toH - 12 : toH;
          
          timeSpan += timeSpan ? ' or ' : '';
          timeSpan += \`\${fromH}:\${(fromM + '').length === 1 ? '0' + fromM : fromM} \${fromAmPm}\`;
          timeSpan += \` - \`;
          timeSpan += \`\${toH}:\${(toM + '').length === 1 ? '0' + toM : toM} \${toAmPm}\`;
        });
        
        updateCurrentTimeIntervalRef = setInterval(() => (this.updateCurrentTime(schedule)), 1000);
        
        DEFAULT_MESSAGES.CHAT_SCHEDULE = DEFAULT_MESSAGES.CHAT_SCHEDULE.replace('{schedule}', timeSpan);
  
        if (this.settings.phone) {
          this.shadowRoot.querySelector('#call').classList.remove('hidden');
          this.shadowRoot.querySelector('#call').href = \`tel:\${this.settings.phone}\`;
          this.shadowRoot.querySelector('.call-us.message').innerHTML = \`Call us at \${this.settings.phone}\`;
        } else {
          this.shadowRoot.querySelector('#call').classList.add('hidden');
        }
        
        if (this.settings.email) {
          this.shadowRoot.querySelector('#email').classList.remove('hidden');
          this.shadowRoot.querySelector('#email').href = \`mailto:\${this.settings.email}\`;
          this.shadowRoot.querySelector('.email-us.message').innerHTML = this.settings.email;
        } else {
          this.shadowRoot.querySelector('#email').classList.add('hidden');
        }
      }
  
      updateStoredSettings() {
        return new Promise((resolve, reject) => {
          let storedSettings = JSON.parse(localStorage.getItem('ECSWebChat.config'));
          
          const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
          
          const storedSettingsLastLocalUpdate = new Date(storedSettings && storedSettings.lastLocalConfigUpdate);
          const isStoredSettingsLastLocalUpdateValid = !isNaN(storedSettingsLastLocalUpdate);
          
          const storedSettingsLastServerUpdate = new Date(storedSettings && storedSettings.updatedAt);
          const isStoredSettingsLastServerUpdateValid = !isNaN(storedSettingsLastServerUpdate);
          
          if (
            !storedSettings 
            || (isStoredSettingsLastLocalUpdateValid && storedSettingsLastLocalUpdate < thirtyDaysAgo) 
            || (isStoredSettingsLastServerUpdateValid && storedSettingsLastServerUpdate < thirtyDaysAgo)
          ) {
            fetch(\`\${baseSetup.proactiveChatConfigAPI}/\${baseSetup.configId}\`)
              .then(r => r.json())
              .then(config => {
                config.lastLocalConfigUpdate = new Date().toISOString();
                localStorage.setItem('ECSWebChat.config', JSON.stringify(config));
                this.settings = config;
                resolve(this.settings);
              })
              .catch(reject);
          } else {
            resolve(this.settings);
          }
        });
      }
    }
  
    window.customElements.define('ecs-spinner', ECSSpinner);
    window.customElements.define('ecs-web-chat', ECSWebChat);
    window.addEventListener('beforeunload', () => (clearInterval(updateCurrentTimeIntervalRef))); 
    document.body.appendChild(document.createElement('ecs-web-chat'));
  `
    .replace(/\s\s+/g, ' ')
    .trim();
};
